import { useState } from 'react'
import { exportLeadsCsv } from '../api/leadService'
/* CSV export action: idle | loading | success | empty | error */
export default function ExportCsvButton({ rows }) {
  const [s, setS] = useState('idle')
  const go = async () => {
    setS('loading')
    try {
      const csv = await exportLeadsCsv(rows)
      if (!csv) return setS('empty')
      const url = URL.createObjectURL(new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })); const a = document.createElement('a'); a.href = url; a.download = 'leads.csv'; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url); setS('success')
    } catch { setS('error') }
  }
  const label = { idle: '⬇ Export CSV', loading: 'Exporting…', success: '✔ Exported', empty: 'Nothing to export', error: '⚠ Failed – retry' }[s]
  return <button className={`btn btn-${s === 'error' ? 'danger' : 'outline-primary'}`} disabled={s === 'loading'} onClick={go}>{label}</button>
}
